import Visual from './Visual.vue'

export default Visual



// WEBPACK FOOTER //
// ./node_modules/gvue/src/core/Visual/index.js